// @flow

import React from 'react';

const LeftIcon = () => (
  <g id='Icon=left'>
    <path id='Vector' d='M10.3537 12.6465C10.4001 12.693 10.437 12.7481 10.4621 12.8088C10.4872 12.8695 10.5002 12.9346 10.5002 13.0003C10.5002 13.066 10.4872 13.131 10.4621 13.1917C10.437 13.2524 10.4001 13.3076 10.3537 13.354C10.3072 13.4005 10.252 13.4373 10.1914 13.4625C10.1307 13.4876 10.0656 13.5006 9.99991 13.5006C9.93421 13.5006 9.86915 13.4876 9.80846 13.4625C9.74776 13.4373 9.69261 13.4005 9.64615 13.354L4.64615 8.35403C4.59967 8.30759 4.56279 8.25245 4.53763 8.19175C4.51246 8.13105 4.49951 8.06599 4.49951 8.00028C4.49951 7.93457 4.51246 7.86951 4.53763 7.80881C4.56279 7.74811 4.59967 7.69296 4.64615 7.64653L9.64615 2.64653C9.73997 2.55271 9.86722 2.5 9.99991 2.5C10.1326 2.5 10.2598 2.55271 10.3537 2.64653C10.4475 2.74035 10.5002 2.8676 10.5002 3.00028C10.5002 3.13296 10.4475 3.26021 10.3537 3.35403L5.70678 8.00028L10.3537 12.6465Z' />
  </g>
);

export default LeftIcon;
